export const LOAD_CONTENT = 'hg/checkout/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/checkout/DL_PAGE_LOADED';
export const SET_DATA = 'hg/checkout/SET_DATA';
export const SET_PRODUCT_ID = 'hg/checkout/SET_PRODUCT_ID';

export * from './checkoutSelectors';

const initialState = {
  loaded: false
};

export const checkout = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

      case SET_PRODUCT_ID:
        return {
          ...state,
          priceReferenceId: action.payload
        };
    default:
      return state;
  }
};

export const loadContent = (payload) => {
  const lowerCaseProductType = typeof payload.type === 'string' ? payload.type.toLowerCase() : 'qc';

  return {
    type: LOAD_CONTENT,
    payload: {
      uid: payload.uid, //LEGACY URL SUPPORT
      productName: payload.sn,
      checkoutType: lowerCaseProductType
    }
  };
};

export const setData = (payload) => {
  return {
    type: SET_DATA,
    payload
  };
};

export const setProductId = (payload) => {
  return {
    type: SET_PRODUCT_ID,
    payload
  };
};

export default checkout;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/checkout/checkout.js
 **/